import { router, Stack } from 'expo-router';
import { Platform } from 'react-native';
import { useStyles } from 'react-native-unistyles';

import BackButton from '@/components/back-button';
import { isDesktop } from '@/core';

export default function PayoutsLayout() {
  const { theme } = useStyles();

  return (
    <Stack>
      <Stack.Screen name="index" options={{ headerShown: false }} />

      {Platform.OS === 'web' && isDesktop() ? (
        <Stack.Screen
          name="[id]"
          options={{
            headerShown: false,
          }}
        />
      ) : (
        <Stack.Screen
          name="[id]"
          options={({ route }) => ({
            headerTitle: `Payout ID: ${route.params?.id ?? ''}`,
            headerLeft: () => (
              <BackButton
                onPress={() => {
                  if (Platform.OS === 'android' && router.canDismiss()) {
                    router.dismiss();
                  }
                  router.navigate('/partner/payouts');
                }}
              />
            ),
            headerBackVisible: false,
            headerShown: true,
            headerStyle: {
              backgroundColor: theme.colors.background_1,
            },
            headerTintColor: theme.colors.text.primary,
            headerShadowVisible: false,
            headerTitleAlign: 'center',
          })}
        />
      )}
    </Stack>
  );
}
